import { AppUtils } from '../../shared/utils/index';
import { BasicValidationService } from './BasicValidationService';

export class VesDamageValidationService extends BasicValidationService<VesDamageAppDefinition> {
	private readonly errorFileValidationTypeAttr: string;

	constructor(app: { options: BasicAppOptions<VesDamageAppDefinition> }, forms: JQuery, checkMarkOnCheckboxField: boolean) {
		super(app, forms);
		this.errorFileValidationTypeAttr = 'error-file-validation-type';
		this.noCheckMarkFieldTypes = '[type=checkbox]';
		if (checkMarkOnCheckboxField) {
			this.noCheckMarkFieldTypes = '';
		}

		this.rowClass = '.js-row';
	}

	public removeErrorOnChange($element: JQuery): void {
		const $parent = $element.parents('.js-row').first();

		$parent.removeClass('is-check').removeClass('is-error');
	}

	/**
	 * Removes all error validations for the error messages and the error fields
	 */
	public removeDependedErrorsOnSchadentypChange(): void {
		const errorMessageDivs = this.$ctx.find('.js-row.depends-on-schadentyp.is-error.is-check');
		if (errorMessageDivs && errorMessageDivs.length > 0) {
			errorMessageDivs.removeClass('is-check is-error');

			const errorElements = errorMessageDivs.find('.is-error');
			if (errorElements && errorElements.length > 0) {
				errorElements.removeClass('is-error');
			}
		}
	}

	public resetErrorMessages(container: JQuery): void {
		const validationClasses = 'is-error is-check is-valid valid';
		const $inputElem = $(container).find('input');
		if ($(container).hasClass('js-upload-container')) {
			$(container).find('.js-file-upload').removeClass(validationClasses);
		}
		$(container).removeClass(validationClasses);
		$inputElem.removeClass(validationClasses);
		$inputElem.removeAttr(this.errorFileValidationTypeAttr);
	}

	/**
	 * _addCustomMethods.
	 *
	 * add custom validation methods
	 *
	 */
	protected addCustomMethods(): void {
		super.addCustomMethods();
		$.validator.addMethod('requiredUploadedFile', this.validatorRequiredUploadedFile.bind(this));
		$.validator.addMethod('allowedfiletype', this.validatorAllowedfiletype.bind(this));
		$.validator.addMethod('maxfilesize', this.validatorMaxfilesize.bind(this));
		$.validator.addMethod('maxfilesizesummary', this.validatorMaxfilesizesummary.bind(this));
		$.validator.addMethod('maxfilecount', this.validatorMaxfilecount.bind(this));
		$.validator.addMethod('onlySelectedFiles', this.validatorOnlySelectedFiles.bind(this));
		$.validator.addMethod('emptyActiveCostType', this.validatorEmptyActiveCostType.bind(this));
		$.validator.addMethod('requirediban', this.validatorRequirediban.bind(this));
		$.validator.addMethod('requiredsum', this.validatorRequiredsum.bind(this));
		$.validator.addMethod('requiredmindate', this.validatorRequiredMinDate.bind(this));
	}

	protected validatorRequiredUploadedFile(value: any, element: HTMLElement): boolean {
		if (this.isFormSubmit && !$(element).hasClass('js-file-stored')) {
			return false;
		}
		return true;
	}

	protected validatorAllowedfiletype(value: any, element: HTMLElement): boolean {
		return this.validateFileValidationType(element, 'allowedFiletype');
	}
	protected validatorMaxfilesize(value: any, element: HTMLElement): boolean {
		return this.validateFileValidationType(element, 'maxFileSize');
	}
	protected validatorMaxfilesizesummary(value: any, element: HTMLElement): boolean {
		return this.validateFileValidationType(element, 'maxFileSizeSummary');
	}
	protected validatorMaxfilecount(value: any, element: HTMLElement): boolean {
		return this.validateFileValidationType(element, 'maxFileCount');
	}

	private validateFileValidationType(element: HTMLElement, fileValidationType: string): boolean {
		if ($(element).attr(this.errorFileValidationTypeAttr) === fileValidationType) {
			return false;
		}
		return true;
	}

	protected validatorOnlySelectedFiles(value: any, element: HTMLElement): boolean {
		if (this.isFormSubmit && $(element).hasClass('js-file-stored') === false && $(element).prop('files')[0] !== undefined) {
			return false;
		}
		return true;
	}

	protected validatorEmptyActiveCostType(value: any, element: HTMLElement): boolean {
		if (this.isFormSubmit && $(element).parents('.js-upload').first().find('.js-file-stored').length === 0) {
			return false;
		}
		return true;
	}
	protected validatorRequirediban(value: any): boolean {
		if (value && value.length > 0) {
			return true;
		}
		return false;
	}
	protected validatorRequiredsum(value: any, element: HTMLElement): boolean {
		if (value && value.length > 0) {
			return true;
		} else {
			const $uploadData = $(element).closest('.js-file-sum').prev('.js-file-upload').find('.js-data').first();
			if ($uploadData.hasClass('is-active')) {
				return false;
			}
		}
		return true;
	}
	protected validatorRequiredMinDate(value: any, element: HTMLElement, params: any): boolean {
		const date = AppUtils.Format.viewDateToIsoDate(value);
		if (date && date.length > 0) {
			const cutOffDate = moment(params, "DD.MM.YYYY");
			const entryDate = moment(value, "DD.MM.YYYY");
			return entryDate.isSame(cutOffDate) || entryDate.isAfter(cutOffDate);
		}
		return false;
	}
	public setServerValidationFlags(success: boolean, errorFlags: Array<string>): void {
		$.each(errorFlags, (key, flag) => {
			this.setServerValidationFlag(success, flag);
		});
	}

	public triggerValidationAndScrollToError(errorIds: string[], inputScrollTo: JQuery): void {
		this.triggerValidation(errorIds);
		this.scrollTo(inputScrollTo);
	}
}
